import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import get from "lodash/get";
import { withSnackbar } from "notistack";
import React from "react";
import { SwatchesPicker } from "react-color";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import shiftPlannerDemo from "Assets/Svg/shift-planner-demo.png";
import Tooltip from "@material-ui/core/Tooltip";

import {
  setHelperText,
  ShiftPlanner,
} from "../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../Actions/LanguageAction";

const styles = (theme) => ({
  root: {
    width: "90%",
  },
  backButton: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  customWidth: {
    maxWidth: 700,
    height: 160,
    maxHeight: "500px !important",
  },
});
class ShiftColor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      shiftcolour: "",
      color: "",
      helperText: "",
    };
    this.onBeforeUpload = this.onBeforeUpload.bind(this);
  }

  componentWillMount() {
    this.props.ChangeLanguage("allshiftplanner");
  }

  componentDidMount() {
    window.addEventListener("beforeunload", this.onBeforeUpload);
    if (this.props.Language.allshiftplanner) {
      const text = this.props.Language.allshiftplanner.LbColorCode;
      this.props.setHelperText({ helperText: text });
    }

    const shiftPlannerInfo = this.props.shiftPlannerReducer;

    if (!this.isEmpty(shiftPlannerInfo)) {
      const shiftcolour = shiftPlannerInfo.shiftcolour
        ? shiftPlannerInfo.shiftcolour
        : null;
      if (shiftcolour) this.handleChange(shiftcolour);
      this.setState({ shiftcolour });
    }

    this.props.onRef({
      onNext: this.OnNext,
    });
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onBeforeUpload);
    this.props.StepError(4, false);
  }

  onBeforeUpload(e) {
    e.returnValue = "Are you sure you want to close the window/tab?";
  }

  componentWillReceiveProps(props) {
    const shiftPlannerInfo = props.shiftPlannerReducer;

    if (!this.isEmpty(shiftPlannerInfo)) {
      const { shiftcolour } = shiftPlannerInfo;
      this.setState({ shiftcolour });
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }

  handleChange(color) {
    this.setState({ shiftcolour: color.hex }, () => {
      this.UpdateShiftPlannerReducer();
    });
  }

  UpdateShiftPlannerReducer() {
    const shiftPlannerInfo = this.props.shiftPlannerReducer;
    shiftPlannerInfo.shiftcolour = this.state.shiftcolour
      ? this.state.shiftcolour
      : null;
    this.props.ShiftPlanner({ ...shiftPlannerInfo });
  }

  Validate() {
    let isValid = true;
    let ErShiftColor = false;
    if (!this.state.shiftcolour) {
      ErShiftColor = true;
      this.setState({ ErShiftColor });

      return (isValid = false);
    }

    this.setState({ ErShiftColor });
    return isValid;
  }

  OnNext = () => {
    if (!this.state.shiftcolour) {
      this.setState({ ErShiftColor: true });
      this.props.StepError(4, true);
    } else {
      this.props.StepError(4, false);
      this.UpdateShiftPlannerReducer();
      this.props.click();
    }
  };

  OnSaveAsDraft() {
    if (!this.state.shiftcolour) {
      this.setState({ ErShiftColor: true });
      this.props.StepError(4, true);
    } else {
      this.props.StepError(4, false);
      this.setState({ ErShiftColor: false });
      this.UpdateShiftPlannerReducer();
      // this.props.SaveAsDraft(true)
    }
  }

  OnCancel() {
    this.props.Cancel(true);
  }

  HelperSliderFlag(HtField) {
    const text = get(this.props, `Language.allshiftplanner[${HtField}]`);
    // let text = this.props.Language.allshiftplanner[HtField]
    this.props.setHelperText({ helperText: text, open: true });
  }

  render() {
    const { classes } = this.props;
    return (
      <Grid container>
        <Grid item xs={12} md={12} sm={12} className="">
          <div
            tabIndex="0"
            className="active-color display-flex margin-bottom-8"
          >
            {/* <FormattedMessage id="__LbColorCode" defaultMessage="What will be the color code for this shifts?" /> */}
            <span className="margin-right-8">
              Choose a color code for this shift
            </span>
            {/* <Tooltip
              classes={{
                tooltip: classes.customWidth,
              }}
              title={
                <div style={{ display: "block", Maxwidth: 700 }}>
                  <br />
                  <span
                    className="t-backgroundColor"
                    style={{ display: "block", Maxwidth: 700 }}
                  >
                    The color will be displayed in the shift planner to identify
                    this shift
                  </span>
                  <br />
                  <br />
                  <img src={shiftPlannerDemo} style={{ width: 600 }}></img>
                  <br />
                </div>
              }
              placement="right"
            >
              <span>ℹ️</span>
            </Tooltip> */}

            <div className="shift-color-code-info">
              ℹ️
              <div className="rounded-rectangle-paper padding8 shift-color-code-inner">
                <p className="small-dark margin-bottom-16 t-bold">
                  The color will be displayed in the shift planner to identify
                  this shift
                </p>
                <img src={shiftPlannerDemo} style={{ width: 660 }}></img>
              </div>
            </div>
          </div>
          <SwatchesPicker
            colors={[
              ["#c5cae9", "#ffcdd2", "#fff3e0", "#fce4ec"],
              ["#e0f7fa", "#eceff1", "#efebe9", "#d7ccc8"],
              ["#cfd8dc", "#e3f2fd", "#fff9c4", "#b2dfdb"],
              ["#c8e6c9", "#e0e0e0", "#ffe0b2", "#f3e5f5"],
              ["#e6ee9c", "#e8f5e9", "#c3d5ea", "#fbe9e7"],
            ]}
            color={this.state.shiftcolour}
            width="400px"
            height="200px"
            overflowY="hidden"
            className="colorpicker"
            onChange={this.handleChange.bind(this)}
            // onFocus={this.HelperSliderFlag.bind(this, "LbColorCode")}
          />
          <div>
            {this.state.ErShiftColor == true ? (
              <span className="caption-error">
                <FormattedMessage
                  id="ErShiftColor"
                  defaultMessage="Please select color code"
                />
              </span>
            ) : (
              ""
            )}
          </div>
          {/* <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={this.OnNext.bind(this)}
          >
            <FormattedMessage id="BtNext" defaultMessage="next" />
          </Button> */}
          {/* <div className="draftbutton-wrapper">
                <div className="draftclosebutton cursour-pointer" onClick={this.OnCancel.bind(this)}>X <span className="draftclosebutton-text"><FormattedMessage id="BtClose" defaultMessage="Close" /></span></div>
                <div className="draftbutton-innerwrapper">
                    <span className="draftbutton cursour-pointer" onClick={this.OnSaveAsDraft.bind(this)}><Done /> <span className="draft-option"><FormattedMessage id="BtSaveAsDraft" defaultMessage="Save As Draft" /></span></span>

                </div>
            </div> */}
        </Grid>
      </Grid>
    );
  }
}

const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  shiftPlannerReducer: state.shiftPlannerReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      ShiftPlanner: (data) => ShiftPlanner(data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withSnackbar(ShiftColor)));
